<template>
<div class="clubSignUp">
  <img class="clubSignUp__left" :src="require('@/assets/img/club/signup.png')"/>
  <section class="clubSignUp__right">
    <form class="clubSignUp__form">
      <label class="clubSignUp__textLabel">Имя</label>
      <form-input v-model="clubSignUpStore.firstName" :name-only="true"/>

      <label class="clubSignUp__textLabel">Фамилия</label>
      <form-input v-model="clubSignUpStore.lastName" :name-only="true"/>

      <label class="clubSignUp__textLabel">Почта</label>
      <form-input v-model="clubSignUpStore.email"/>

      <label class="clubSignUp__textLabel">Область, Город </label>
      <form-input v-model="clubSignUpStore.city"/>


      <label class="clubSignUp__textLabel">Номер телефона для связи</label>
      <phone-input v-model="clubSignUpStore.phone" :error="phoneError"/>

      <label class="clubSignUp__textLabel">Навыки и компетенции, которыми обладаете ('рисую', 'python', 'аналитик данных'). </label>
      <form-input
          rows="3"
          height="77px"
          v-model="clubSignUpStore.info"
      />

      <label class="clubSignUp__textLabel--muted ">
        Эта информация поможет подобрать близкий по духу круг для творческих собраний и инициатив
      </label>

      <CheckBox
          v-model="acceptFirst"
      >
        Я соглашаюсь <ConsentLink slug="consent-club">с уставом и условиями Клуба КиберДеда</ConsentLink>
      </CheckBox>
      <CheckBox
          v-model="acceptSecond"
          text=""
      >
        Я соглашаюсь на <ConsentLink slug="consent-personal">обработку персональных данных</ConsentLink>

      </CheckBox>

      <div class="clubSignUp__Buttons">
        <ActionButton
            style="width: 180px"
            icon-type="arrow"
            @button-click="clubSignUpHandler"
        >
          <template #caption>Подать заявку</template>
        </ActionButton>
        <ActionButton
            style="width: 180px"
            @button-click="$router.push({name: 'ClubView'})"
        >
          <template #caption>Отмена</template>
        </ActionButton>

      </div>

    </form>
  </section>

</div>
</template>

<script>
import CheckBox from "@/components/ui/CheckBox.vue";
import ActionButton from "@/components/ui/ActionButton.vue";
import FormInput from "@/components/ui/FormInput.vue";
import PhoneInput from "@/components/ui/PhoneInput.vue";
import ConsentLink from "@/components/ui/ConsentLink.vue";
import {useClubSignUpStore} from "@/store/club-signup";
import {computed, onMounted, ref} from "vue";
import {useRouter} from "vue-router";
import {useToast} from "vue-toast-notification";
import {checkPhone} from "@/tools/validation.tools";


export default {
  name: "ClubSignUpView",
  components: {FormInput, PhoneInput, ActionButton, CheckBox, ConsentLink},
  setup() {
    const router = useRouter();
    const toast = useToast();
    const clubSignUpStore = useClubSignUpStore();
    const acceptFirst = ref(null)
    const acceptSecond = ref(null)

    const phoneError = computed(() => checkPhone(clubSignUpStore.phone, true) ? '' : 'Введите полный номер телефона');

    onMounted( () => {
      console.log('ClubSignUpView mounted');
      clubSignUpStore.fillFromUserSettings();
    })

    async function clubSignUpHandler() {
      console.log('clubSignUpHandler invoked');
      await clubSignUpStore.clubSignUp()
      if(clubSignUpStore.error) {
        toast.error(clubSignUpStore.error);
        return;
      }
      await router.push({name: 'ClubSignUpFinishView'})
    }

    return {
      clubSignUpStore, acceptFirst, acceptSecond, clubSignUpHandler, phoneError
    }
  }
}
</script>


<style scoped lang="scss">
.clubSignUp {
  display: flex;
  padding-top: 60px;
  gap: 22px;
  &__left {
    border-radius: 20px;
  }
  &__right {
    border-radius: 20px;
    background: var(--cd-card-bg);
    padding: 34px;
    width: 731px;
  }

  &__textLabel {
    padding: 10px 10px;
    display: block;
  }
  &__textLabel--muted {
    display: block;
    color: var(--cd-text-muted);
    margin: 20px 0px;
  }

  &__form {
    text-align: left;
    width: 663px;
    font-size: 14px;
    font-weight: 400;
    font-family: var(--cd-default-font);
  }
}
</style>
